const getFiatList = () => {
  try {
    const list = process.env.VUE_APP_FIAT_LIST;
    return list ? JSON.parse(list) : [];
  } catch (e) {
    console.error('Error parsing VUE_APP_FIAT_LIST:', e);
    return [];
  }
};

export default {
  token: null,
  refreshToken: null,
  id: null,
  userData: {},
  fiatList: getFiatList(),
  paymentCurrencyKey: process.env.VUE_APP_DEFF_PAYMENT_CURRENCY_KEY || 'EUR',
}
